import React from 'react';
import PropTypes from 'prop-types';

import { Card, CardActions, CardHeader, CardText } from 'material-ui/Card';
import IconAttachment from 'material-ui/svg-icons/editor/attach-file';
import Chip from '../Common/Chip';
import FlatButton from 'material-ui/FlatButton';

const iconProps = {
    color: 'rgba(117, 117, 117 ,0.7)'
};

const CourseLabelSegment = ({labels, addAction, deleteAction}) => (

    <Card className="cent-card">
        <CardHeader
            title="Labels"
            avatar={<IconAttachment {...iconProps}/>}
        />
        <CardText className="cent-card-text">
            {labels.map((label) => (
                <Chip
                    key={label.id}
                    label={label.name}
                    onDelete={() => deleteAction(label.id)}
                    theme="secondary"
                />
            ))}
        </CardText>
        <CardActions>
            <FlatButton label="Add" onTouchTap={addAction} />
        </CardActions>
    </Card>
);

CourseLabelSegment.propTypes = {
    labels:         PropTypes.arrayOf(PropTypes.object),
    addAction:      PropTypes.func,
    deleteAction:   PropTypes.func
};

export default CourseLabelSegment;
